export enum LetterState {
  DEFAULT = "Default",
  CORRECT = "Correct",
  IN_WORD = "In Word",
  INCORRECT = "Incorrect",
}
